<template>
  <div class="bg-light-gray px-4 py-3 rounded">
    <div class="mb-3">
      <icon-view
        :has-border="false"
        icon="fas fa-file-plus text-orange"
        icon-size="17px"
        title="Añadir Equipo"
        variant="custom-icon-view"
        icon-background="white"
      />
    </div>

    <validation-observer ref="addEquipmentObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 col-md">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              label="Categoría en Catálogo de Cumplimiento:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione una categoría"
              v-model="model.classification"
              :options="classifications"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md ">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-input
              v-model="model.name"
              custom-error-msg="El nombre de equipo MiPE es requerido"
              :error="errors[0]"
              label="Nombre de Equipo MiPE:"
              placeholder="Nombre de Equipo MiPE"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-3 mt-3 mt-md-0">
          <div
            class="d-flex align-items-center h-100"
            :class="{ 'flex-column': isMobile }"
          >
            <div :class="{ 'w-100 mb-2': isMobile }">
              <action-button
                id="btnCancel"
                i="fas fa-times-circle"
                text="Cancelar"
                :variant="
                  isMobile ? 'outline-danger mr-2 w-100' : 'outline-danger mr-2'
                "
                @click="cancel"
              />
            </div>
            <div :class="{ 'w-100': isMobile }">
              <action-button
                id="btnSave"
                i="fas fa-file-plus"
                text="Añadir"
                :variant="isMobile ? 'success w-100' : 'success'"
                @click="save"
              />
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import IconView from 'icon-view';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import referralService from '@/services/api/referralsandequipments.api';
import inventoryCatalogService from '@/services/api/inventorycatalog.api';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';

export default {
  name: 'AddEquipment',
  components: {
    IconView,
    CustomDropDown,
    CustomInput,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {},
  data() {
    return {
      classifications: [],
      model: {
        classification: null,
        name: null,
      },
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
  },
  mounted() {
    this.getClassifications();
  },
  methods: {
    async getClassifications() {
      const { data } = await referralService.getEquipmentClassifications();
      this.classifications = data;
    },
    cancel() {
      this.$emit('cancel');
    },
    async save() {
      const valid = await this.$refs.addEquipmentObserver.validate();
      if (!valid) {
        this.ShowToast(
          'Alerta',
          'Por favor, completa los campos requeridos.',
          'error'
        );
        return;
      }
      try {
        const payload = {
          name: this.model.name,
          classificationId: this.model.classification.id,
        };
        await inventoryCatalogService.addCatalog(payload);
        this.ShowToast('', 'Equipo añadido con éxito.', 'success');
        this.$emit('save');
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dot {
  padding: 19px !important;
}
</style>
